import { __require as requireOutside } from "./outside.js";
var gtr_1;
var hasRequiredGtr;
function requireGtr() {
  if (hasRequiredGtr) return gtr_1;
  hasRequiredGtr = 1;
  const outside = requireOutside();
  const gtr = (version, range, options) => outside(version, range, ">", options);
  gtr_1 = gtr;
  return gtr_1;
}
export {
  requireGtr as __require
};
//# sourceMappingURL=gtr.js.map
